import React from 'react';
import DOMPurify from 'dompurify';
const Sanitized = ({ description }) => {
    const sanitizedHtml = DOMPurify.sanitize(description);
    return (
        <div
            dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
        ></div>
    );
};

export default Sanitized;